import {gsap, TimelineLite} from "gsap";
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/reel/winpresentation/SimplePresentationRunner";
import {DumpsterFire} from "../../DumpsterFire";
import {DumpsterFireGameMode} from "../../server/DumpsterFireGameMode";
import {DumpsterFireSymbol, SYMBOL_NAME} from "../../reels/DumpsterFireSymbol";
import {ISymbol} from "../../../core/reel/simplereel/IReelData";
import {DumpsterFireSound} from "../../sound/DumpsterFireSound";
import {NolimitApplication} from "@nolimitcity/slot-keypad/bin/core/app/NolimitApplication";

export class DFScatterRunner implements SimplePresentation {
    private _mainTl: TimelineLite;

    shouldRun(): boolean {
        return DumpsterFire.model.numOfScatter.length > 0 && !DumpsterFire.model.gameData.brokeTheBank && DumpsterFire.model.data.nextMode !== DumpsterFireGameMode.FREESPIN_AVALANCHE
            && !((DumpsterFire.model.gameData.scatterWins.length > 0 || DumpsterFire.model.isXBombPresent) && (DumpsterFire.model.data.nextMode === DumpsterFireGameMode.NORMAL || DumpsterFire.model.data.nextMode === DumpsterFireGameMode.EXTRA_SPIN))
    }

    start(controller: SimplePresentationRunnerController): void {
        this._mainTl = new TimelineLite({
            delay: 0.001,
            onStart: () => {
                this._mainTl.add(DumpsterFire.reelAnticipation.hideContainer(), 0);
            },
            onComplete: () => {
                DumpsterFire.model.numOfScatter = [];
                controller.finish();
            }
        });
        this._mainTl.add(() => {
            controller.setSkipCallback(() => this.onSkip());
        }, 0.001);

        const evaluatedArea: string[][] = DumpsterFire.model.gameData.evaluatedReels,
            isUpgradedScatter: boolean = DumpsterFire.model.findUpgradedSymbol(SYMBOL_NAME.SCATTER);
        let soundPlayed: boolean = false;
        let toPosX = 880,
            toPosY = 510;
        if (!NolimitApplication.isLandscape) {
            toPosX = 360;
            toPosY = 800;
        }
        evaluatedArea.forEach((reel: string[], reelId: number) => {
            reel.forEach((symbol: string, rowId: number) => {
                if (symbol === "S") {
                    let symbol: ISymbol = DumpsterFire.allReelsView.getSymbolAtPosition(reelId, rowId);
                    if (DumpsterFire.model.data.reels[reelId][rowId] === SYMBOL_NAME.SCATTER) {
                        this._mainTl.add([DumpsterFire.winView.playTriggerAnimation(<DumpsterFireSymbol>symbol),
                            () => {
                                if (!soundPlayed) {
                                    DumpsterFire.soundPlayer.playSound(DumpsterFireSound.FS_PLUS_SPIN);
                                    soundPlayed = true;
                                }
                            }], 0);
                    }
                    const extraSpinText: string = isUpgradedScatter ? "+2" : "+1"; // Set the spin text based on scatter type
                    this._mainTl.add(DumpsterFire.scatterView.extraSpinAward(reelId, rowId, toPosX, toPosY, extraSpinText), "<0.2");
                }
            });
        });
        this._mainTl.add(gsap.to(this, {duration: 0.002}));
    }

    private onSkip(): void {
        this._mainTl.timeScale(3);
    }
}